"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropEmotionalCheckInDismissMethodEnum = exports.PropEmotionalCheckInButtonLocationEnum = exports.PropEmotionalCheckInSoundStateEnum = exports.PropEmotionalCheckInEmotionEnum = void 0;
exports.PropEmotionalCheckInEmotionEnum = {
    Enjoyment: 'Enjoyment',
    Sadness: 'Sadness',
    Fear: 'Fear',
    Anger: 'Anger',
    Disgust: 'Disgust',
};
exports.PropEmotionalCheckInSoundStateEnum = {
    On: 'On',
    Off: 'Off',
};
exports.PropEmotionalCheckInButtonLocationEnum = {
    HomePod: 'HomePod',
    ViewHistoryLink: 'ViewHistoryLink',
    EmotionalCheckinResults: 'EmotionalCheckinResults',
};
exports.PropEmotionalCheckInDismissMethodEnum = {
    Close: 'Close',
    MaybeLater: 'MaybeLater',
    OutsideOfModal: 'OutsideOfModal',
};
//# sourceMappingURL=prop-emotional-check-in.js.map